export const QUESTION_MAX_LENGTH = 28;
export const OPTION_NOT_REQUIRED = 3;

export const CREATION_INITIAL_STATE = {
  question: "",
  option1: "",
  option2: "",
  option3: "",
  image1: "",
  image2: "",
  image3: "",
};

export const INPUTS_INITIAL_STATE = [
  {
    name: "question",
    id: 0,
    isInvalid: false,
    isImageInvalid: false,
    type: "question",
  },
  {
    name: "option 1",
    id: 1,
    isInvalid: false,
    isImageInvalid: false,
    type: "option",
  },
  {
    name: "option 2",
    id: 2,
    isInvalid: false,
    isImageInvalid: false,
    type: "option",
  },
  {
    name: "option 3",
    id: 3,
    isInvalid: false,
    isImageInvalid: false,
    type: "option",
  },
];
